// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/**
 * What the monitoring editor exchanges with Harvest's `/monitoring/*` routes,
 * through their Hasura actions. Only what the editor needs: the view's own
 * types live in `../types.ts`.
 */
/** The kinds of configuration document an event stores. */
export var EMonitoringConfigKind;
(function (EMonitoringConfigKind) {
    EMonitoringConfigKind["DASHBOARD"] = "dashboard";
    EMonitoringConfigKind["WIDGET"] = "widget";
    EMonitoringConfigKind["THEME"] = "theme";
    EMonitoringConfigKind["SETTINGS"] = "settings";
})(EMonitoringConfigKind || (EMonitoringConfigKind = {}));
export var EMonitoringProblemSeverity;
(function (EMonitoringProblemSeverity) {
    EMonitoringProblemSeverity["ERROR"] = "ERROR";
    EMonitoringProblemSeverity["WARNING"] = "WARNING";
})(EMonitoringProblemSeverity || (EMonitoringProblemSeverity = {}));
export var EMonitoringRenderState;
(function (EMonitoringRenderState) {
    EMonitoringRenderState["RENDERED"] = "RENDERED";
    EMonitoringRenderState["NOT_CONNECTED"] = "NOT_CONNECTED";
    EMonitoringRenderState["NO_SNAPSHOT"] = "NO_SNAPSHOT";
    EMonitoringRenderState["SCOPE_PENDING"] = "SCOPE_PENDING";
    EMonitoringRenderState["RENDER_FAILED"] = "RENDER_FAILED";
    EMonitoringRenderState["INVALID"] = "INVALID";
})(EMonitoringRenderState || (EMonitoringRenderState = {}));
export var EMonitoringColorScheme;
(function (EMonitoringColorScheme) {
    EMonitoringColorScheme["LIGHT"] = "LIGHT";
    EMonitoringColorScheme["DARK"] = "DARK";
})(EMonitoringColorScheme || (EMonitoringColorScheme = {}));
export var EMonitoringValidationResult;
(function (EMonitoringValidationResult) {
    EMonitoringValidationResult["VALID"] = "VALID";
    EMonitoringValidationResult["INVALID"] = "INVALID";
})(EMonitoringValidationResult || (EMonitoringValidationResult = {}));
export var EMonitoringSaveChange;
(function (EMonitoringSaveChange) {
    EMonitoringSaveChange["UPSERT"] = "UPSERT";
    EMonitoringSaveChange["DELETE"] = "DELETE";
})(EMonitoringSaveChange || (EMonitoringSaveChange = {}));
/** What a save came to: stored, refused because someone saved first, or refused as invalid. */
export var EMonitoringSaveStatus;
(function (EMonitoringSaveStatus) {
    EMonitoringSaveStatus["SAVED"] = "SAVED";
    EMonitoringSaveStatus["CONFLICT"] = "CONFLICT";
    EMonitoringSaveStatus["INVALID"] = "INVALID";
})(EMonitoringSaveStatus || (EMonitoringSaveStatus = {}));
/** The dashboard selectors, in the order the header shows them. */
export var EMonitoringScopeSelector;
(function (EMonitoringScopeSelector) {
    EMonitoringScopeSelector["REGION"] = "region";
    EMonitoringScopeSelector["POST"] = "post";
    EMonitoringScopeSelector["COUNTRY"] = "country";
})(EMonitoringScopeSelector || (EMonitoringScopeSelector = {}));
export var MONITORING_GRID_COLUMNS = 12;
/** What Duplicate, from the dashboard's widget menu, came to. */
export var EDuplicateResult;
(function (EDuplicateResult) {
    /** The copy is saved and placed after the original. */
    EDuplicateResult["DONE"] = "DONE";
    /** The copy was refused; nothing changed. */
    EDuplicateResult["NOT_SAVED"] = "NOT_SAVED";
    /** The copy is saved, but the dashboard refused to take it. */
    EDuplicateResult["NOT_PLACED"] = "NOT_PLACED";
})(EDuplicateResult || (EDuplicateResult = {}));
